<template>
  <div class="catalog-tabs-container">
    <nav class="responsive-tab style-2 catalog-tabs">
      <ul>
        <li ref="tab-0" :class="{ 'uk-active': activeTab === 0 }">
          <a :disabled="loading" @click.prevent="onClick(0, 'can_register_trainings')">
            <span class="tab-text">{{ $t("general.i_can_register") }}</span>
            <span class="tab-count">
              <span v-if="activeTab === 0 && !loading" class="filtered-count">{{ totalFilteredTraining }} /</span>
              {{ counts["countOfRegistrable"] ?? 0 }}
            </span>
          </a>
        </li>
        <li ref="tab-1" :class="{ 'uk-active': activeTab === 1 }">
          <a :disabled="loading" @click.prevent="onClick(1, 'show_registered_trainings')">
            <span class="tab-text">{{ $t("general.i_registered") }}</span>
            <span class="tab-count">
              <span v-if="activeTab === 1 && !loading" class="filtered-count">{{ totalFilteredTraining }} /</span>
              {{ counts["countOfRegistered"] ?? 0 }}
            </span>
          </a>
        </li>
        <li ref="tab-2" :class="{ 'uk-active': activeTab === 2 }">
          <a :disabled="loading" @click.prevent="onClick(2, 'requests_trainings')">
            <span class="tab-text">{{ $t("general.requests") }}</span>
            <span class="tab-count">
              <span v-if="activeTab === 2 && !loading" class="filtered-count">{{ totalFilteredTraining }} /</span>
              {{ counts["countOfRequests"] ?? 0 }}
            </span>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: "CatalogTabs",
  props: {
    activeTab: {
      type: Number,
      default: 0
    },
    counts: {
      type: [Object, Array],
      default: () => ({})
    },
    totalFilteredTraining: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick(tabIndex, filterKey) {
      this.$emit('update:activeTab', tabIndex)
      this.$emit('tab-change', { filterKey, tabIndex })
      this.scrollTabToCenter(tabIndex)
    },
    scrollTabToCenter(tabIndex) {
      this.$nextTick(() => {
        const tab = this.$refs[`tab-${tabIndex}`]
        if (tab) {
          tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' })
        }
      })
    }
  }
}
</script>

<style scoped>
.catalog-tabs-container {
  width: 100%;
  overflow: hidden;
}

.catalog-tabs {
  margin: 0;
  padding: 0;
}

.catalog-tabs ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.catalog-tabs ul::-webkit-scrollbar {
  display: none;
}

.catalog-tabs ul li {
  flex-shrink: 0;
}

.catalog-tabs ul li a {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #64748b;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
  white-space: nowrap;
  cursor: pointer;
}

.catalog-tabs ul li a:hover {
  color: #3e416d;
  background-color: #f8fafc;
}

.catalog-tabs ul li.uk-active a {
  color: var(--backgroundColor, #667eea);
  border-bottom-color: var(--backgroundColor, #667eea);
  font-weight: 600;
}

.tab-text {
  font-size: 14px;
  line-height: 1.4;
}

.tab-count {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 12px;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 10px;
  height: fit-content;
  line-height: 1.2;
}

.uk-active .tab-count {
  background: rgba(102, 126, 234, 0.1);
  color: var(--backgroundColor, #667eea);
}

.filtered-count {
  font-weight: 600;
}

/* Responsive - Tablet */
@media (max-width: 959px) {
  .catalog-tabs-container {
    background: #ffffff;
    border-radius: 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    margin-bottom: 16px;
  }

  .catalog-tabs ul li a {
    padding: 12px 16px;
    font-size: 13px;
  }

  .tab-text {
    font-size: 13px;
  }

  .tab-count {
    font-size: 12px;
    padding: 2px 6px;
  }
}

/* Responsive - Mobile */
@media (max-width: 639px) {
  .catalog-tabs-container {
    margin: 0;
    padding: 0;
    border-radius: 14px;
  }

  .catalog-tabs ul {
    padding-left: 0;
  }

  .catalog-tabs ul li a {
    padding: 12px 14px;
    font-size: 13px;
    min-height: 48px;
  }

  .catalog-tabs ul li a:hover {
    background-color: transparent;
  }

  .tab-text {
    font-size: 13px;
  }

  .tab-count {
    font-size: 12px;
  }
}

/* Responsive - Small Mobile */
@media (max-width: 479px) {
  .catalog-tabs-container {
    margin-bottom: 12px;
  }
}
</style>
